import { useContext } from "react";
import { OnboardingContext } from "../context/OnboardingContext";

import OnboardingLayout from "./OnboardingLayout";

import Start from "./Start";
import OrgDetails from "./OrgDetails";
import Billing from "./Billing";
import Limits from "./Limits";
import Legal from "./Legal";
import Finalize from "./Finalize";
import Completed from "./Completed";

export default function OnboardingRouter() {
  const { currentStep } = useContext(OnboardingContext);

  function renderStep() {
    switch (currentStep) {
      case "start":
        return <Start />;
      case "details":
        return <OrgDetails />;
      case "billing":
        return <Billing />;
      case "limits":
        return <Limits />;
      case "legal":
        return <Legal />;
      case "finalize":
        return <Finalize />;
      case "completed": 
        return <Completed />;
      default:
        return <div>Invalid step</div>;
    }
  }

  return <OnboardingLayout>{renderStep()}</OnboardingLayout>;
}